import React, { FunctionComponent, memo } from "react";
import { TimelineItem } from "../../../../store/timelines/types";
import { TimelinePlaybackState } from "../../../../store/playback/types";
import { TimelineSlot } from "./TimelineSlot/TimelineSlot";
import { SlotContent } from "./TimelineSlot/SlotContent";
import { ContentFailureCallback } from "./types";

interface RenderSlot {
  item: TimelineItem | undefined;
  indexInTimeline: number | undefined;
  isPreload: boolean;
  hasNextItem?: boolean;
}

interface StaticViewerProps {
  slot: RenderSlot;
  index: number;
  forcePreloadMode?: boolean;
  isActiveItemTransitioningOut: boolean;
  targetTimelineId: string;
  onContentFailure: ContentFailureCallback;
  playbackState: Pick<TimelinePlaybackState, "activeIndex" | "nextIndex">;
}

export const StaticViewer: FunctionComponent<StaticViewerProps> = memo(
  ({
    slot,
    index,
    forcePreloadMode,
    isActiveItemTransitioningOut,
    targetTimelineId,
    onContentFailure,
    playbackState,
  }: StaticViewerProps) => {
    return (
      <TimelineSlot
        index={index}
        key={index}
        transition={slot.item?.transition}
        isPreload={slot.isPreload}
        isActiveItemTransitioningOut={isActiveItemTransitioningOut}
        targetTimelineId={targetTimelineId}
        indexInTimeline={slot.indexInTimeline}
      >
        {slot.item && !slot.item.isFullscreen && (
          <SlotContent
            item={slot.item}
            isPreload={forcePreloadMode || slot.isPreload}
            hasNextItem={slot.hasNextItem}
            onContentFailure={onContentFailure}
            timelineItemIndex={
              (slot.isPreload
                ? playbackState.nextIndex
                : playbackState.activeIndex) as number
            }
          />
        )}
      </TimelineSlot>
    );
  }
);

StaticViewer.displayName = "StaticViewer";
